import React, { useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/react-hooks';
import {Confirm, Message, Loader } from 'semantic-ui-react';

import AddButton from '../../components/Button/AddButton';
import Table from '../../components/Table';
import Modal from './Modal';

import { FlexContainer, FlexChildren } from '../../components/Dashboard/styles';
import { Container, Header, Title } from './styles';

import { GET_EXCLUSION_RULES } from '../../services/graphql/queries';
import { DELETE_EXCLUSION_RULES } from '../../services/graphql/mutations';

const columns = [
  { id: 'rule', label: 'Regla', minWidth: 100 },
  { id: 'mall', label: 'Centro Comercial', minWidth: 100 },
  { id: 'creation_date', label: 'Fecha de Creación', minWidth: 100 },
  { id: 'active', label: 'Activo', minWidth: 100 },
  {
    id: 'actions',
    label: 'Acciones',
    size: 'small',
    align: 'left'
  }
];

export default function ExclusionRules() {
  const [open, setOpen] = useState(false);
  const [edit, setEdit] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [recordId, setRecordId] = useState(null);
  const [mallsOptions, setMallsOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [selected, setSelected] = useState({});

  const { loading, error, data, refetch } = useQuery(GET_EXCLUSION_RULES);

  const [deleteExclusionRule, { loading: deleteLoading }] = useMutation(
    DELETE_EXCLUSION_RULES
  );

  useEffect(() => {
    if (data && data.getMalls) {
      const malls = data.getMalls.map(mall => ({
        key: mall.id,
        text: `${mall.name} - ${mall.code}`,
        value: mall.id,
        country_id: mall.country_id
      })).filter((data, index) => index !== 0);

      setMallsOptions(malls);
    }

    if (data && data.getCountries) {
      const countries = data.getCountries.map(country => ({
        key: country.id,
        text: country.name,
        value: country.id
      }));

      setCountriesOptions(countries);
    }
  }, [data]);

  function handleEdit(data) {
    setEdit(true);
    setSelected(data);
    setOpen(true);
  }

  function handleAdd() {
    setEdit(false);
    setOpen(true);
  }

  function handleModalClose() {
    refetch();
    setOpen(false);
  }

  function handleOnDeleteClick(id) {
    setRecordId(id);
    setConfirmationOpen(true);
  }

  function handleDelete() {
    deleteExclusionRule({ variables: { id: recordId } });
    setConfirmationOpen(false);
    refetch();
  }

  return (
    <Container>
      <Confirm
        open={confirmationOpen}
        onCancel={() => setConfirmationOpen(false)}
        onConfirm={handleDelete}
        cancelButton="No"
        confirmButton="Si"
        header="Eliminar registro"
        content="¿Estás seguro de que deseas eliminar este registro?"
        data-testid="confirm-delete"
      />
      <FlexContainer>
        <FlexChildren>
          <Header>
            <Title>Lista de Exclusión</Title>
            <AddButton add onClick={handleAdd} />
          </Header>

          {(loading || deleteLoading) && (
            <>
              <br />
              <Loader active inline="centered" />
            </>
          )}
          {error && <Message error header="Error" content={error.message} />}

          {!loading && !error && data && (
            <Table
              data-testid="table"
              data={data ? data.getExclusionRules : null}
              columns={columns}
              handleEdit={handleEdit}
              handleDelete={handleOnDeleteClick}
            />
          )}
          <Modal
            open={open}
            onClose={handleModalClose}
            edit={edit}
            malls={mallsOptions}
            countries={countriesOptions}
            selected={selected}
          />
        </FlexChildren>
      </FlexContainer>
    </Container>
  );
}
